import { useEffect } from 'react'
import { useGlobal } from '../../contexts/GlobalContext'

const Logout = () => {
  const { fazLogout } = useGlobal()

  useEffect( () => {
    fazLogout()
  }, [] )

  return null
}

export default Logout
